
export function useLocalStorage<T>(storageKey: string) {
    let item = {} as T;

    try {
        const storageItem = window.localStorage.getItem(storageKey);
        if (storageItem) {
            item = JSON.parse(storageItem)
        }
    } catch (error) {
        console.error(`Error reading localStorage key "${storageKey}":`, error)
    }

    const get = <K extends keyof T>(key: K)=> item[key];
    const set = <K extends keyof T>(key: K, value: T[K]) => {
        item[key] = value;
        try {
            window.localStorage.setItem(storageKey, JSON.stringify(item))
          } catch (error) {
            console.error(`Error setting localStorage key "${storageKey}":"${key}"`, error)
          }
    }

    return {get,set}
}